export default function useElementFocus() {
    function focus(elementId: string): void {
        document.getElementById(elementId)?.focus()
    }

    return {
        focus,
    }
}
